import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  SecurityScoreComplianceData,
  SecurityScoreDataset,
  SecurityScoreDomeOverview,
} from '../interfaces';
import { environment } from '../../environments/environment';

@Injectable()
export class SecurityScoreService {
  constructor(private http: HttpClient) {}

  fetchSecurityScoreDataset(
    dataType: string,
    viewBy: string,
    limit = 10,
  ): Observable<SecurityScoreDataset> {
    return this.http.get<SecurityScoreDataset>(
      `${environment.baseUrl}/CMDISOSecurityProgramOverview/Dataset`,
      { params: { dataType, viewBy, limit } },
    );
  }

  fetchSecurityScoreDome(
    dataType: string,
    viewBy: string,
    complianceType?: string,
  ): Observable<SecurityScoreDomeOverview> {
    const params: Record<string, string> = {
      surface: 'SecurityProgram',
      dataType,
      viewBy,
    };
    if (complianceType) params['complianceType'] = complianceType;
    return this.http.get<SecurityScoreDomeOverview>(
      `${environment.baseUrl}/CMDISODome/Overview`,
      { params },
    );
  }

  fetchSecurityScoreCompliance(
    viewBy: string,
    complianceType = 'All',
    page = 1,
    pageSize = 50,
  ): Observable<SecurityScoreComplianceData> {
    return this.http.get<SecurityScoreComplianceData>(
      `${environment.baseUrl}/CMDISOSecurityProgramOverview/Compliance`,
      { params: { complianceType, viewBy, page, pageSize } },
    );
  }
}
